<form #accountForm="ngForm" class="form-container">
  <div class="form-header">
    <div class="form-breadcrumb">
      <h3><a [routerLink]="['/account']">Account</a> > {{ account.name || 'Create' }}</h3>
    </div>
    <div class="form-actions">
      <button *ngIf="!isFormDisabled" [disabled]="onSaveDisable" type="submit" mat-flat-button color="primary" (click)="save(accountForm.valid)">
        <mat-icon>save</mat-icon> Save
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-stroked-button (click)="edit()">
        <mat-icon>edit</mat-icon> Edit
      </button>
      <button *ngIf="isFormDisabled" type="button" mat-flat-button color="primary" (click)="create()">
        <mat-icon>add</mat-icon> Create
      </button>
      <button *ngIf="!isFormDisabled" type="button" mat-stroked-button (click)="discardChanges()">Discard</button>
    </div>
  </div>
  <div class="form-card">
    <fieldset [disabled]="isFormDisabled">
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Name</mat-label>
            <input #name="ngModel" type="text" matInput name="name" [(ngModel)]="account.name" required>
            <mat-error *ngIf="name.invalid && name.touched">Required</mat-error>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Type</mat-label>
            <mat-select [disabled]="isFormDisabled" [(value)]="selectedAccountType">
              <input class="select-input" type="text" autocomplete="nope" matInput name="account_type">
              <mat-option *ngFor="let accountType of allAccountTypes" [value]="accountType">{{ accountType | titlecase }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Tally Account</mat-label>
            <input #tally_account="ngModel" type="text" matInput name="tally_account" [(ngModel)]="account.tally_account" required>
            <mat-error *ngIf="tally_account.invalid && tally_account.touched">Required</mat-error>
          </mat-form-field>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-4 mb-3">
          <mat-form-field appearance="fill" class="w-100">
            <mat-label>Company</mat-label>
            <mat-select #company_id (openedChange)="OnCompanyScroll($event)" [disabled]="isFormDisabled || disableCompanySelection" [(value)]="selectedCompany" required>
              <input class="select-input" placeholder="Search..." type="text" autocomplete="nope" (keydown)="$event.stopPropagation()" (keyup)="OnCompanyKey($event)" matInput name="company_list">
              <mat-option *ngFor="let company of allCompanies" [value]="company.id">{{ company.company_name }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </fieldset>
  </div>
  <app-audit-log-viewer model="account" [recordId]="account.id"></app-audit-log-viewer>
</form>
